/**
 * Phase-2 Dropdown Constants
 *
 * Mirror the backend enum values (names sent to the API as-is).
 * Additive utility — does not touch any existing constants.
 *
 * @author Civilhealth Development Team
 */

export interface SelectOption {
  value: string;
  label: string;
}

export const REPORT_TYPES: SelectOption[] = [
  { value: 'PRESCRIPTION', label: 'Prescription' },
  { value: 'BLOOD_REPORT', label: 'Blood Report' },
  { value: 'X_RAY', label: 'X-Ray' },
  { value: 'MRI', label: 'MRI' },
  { value: 'CT_SCAN', label: 'CT Scan' },
  { value: 'ECG', label: 'ECG' },
  { value: 'ECHO', label: 'Echo' },
  { value: 'SONOGRAPHY', label: 'Sonography' },
  { value: 'SURGERY_REPORT', label: 'Surgery Report' },
  { value: 'DISCHARGE_SUMMARY', label: 'Discharge Summary' },
  { value: 'PATHOLOGY_REPORT', label: 'Pathology Report' },
  { value: 'DENTAL_REPORT', label: 'Dental Report' },
  { value: 'EYE_REPORT', label: 'Eye Report' },
  { value: 'OTHER', label: 'Other' },
];

export const DOCUMENT_CATEGORIES: SelectOption[] = [
  { value: 'PRESCRIPTION', label: 'Prescription' },
  { value: 'INVESTIGATION', label: 'Investigation' },
  { value: 'BLOOD_REPORT', label: 'Blood Report' },
  { value: 'INSURANCE', label: 'Insurance' },
  { value: 'ADMISSION', label: 'Admission' },
  { value: 'DISCHARGE_SUMMARY', label: 'Discharge Summary' },
  { value: 'MEDICAL_CERTIFICATE', label: 'Medical Certificate' },
  { value: 'SCAN_REPORT', label: 'Scan Report' },
  { value: 'SURGERY_REPORT', label: 'Surgery Report' },
  { value: 'OTHER', label: 'Other' },
];

export const ACCESS_LEVELS: SelectOption[] = [
  { value: 'PUBLIC', label: 'Public' },
  { value: 'PRIVATE', label: 'Private' },
  { value: 'CONFIDENTIAL', label: 'Confidential' },
];

export const TEST_TYPES: SelectOption[] = [
  { value: 'BLOOD_TEST', label: 'Blood Test' },
  { value: 'URINE_TEST', label: 'Urine Test' },
  { value: 'SUGAR_TEST', label: 'Sugar Test' },
  { value: 'LIPID_PROFILE', label: 'Lipid Profile' },
  { value: 'THYROID_PROFILE', label: 'Thyroid Profile' },
  { value: 'X_RAY', label: 'X-Ray' },
  { value: 'ECG', label: 'ECG' },
  { value: 'ECHO', label: 'Echo' },
  { value: 'MRI', label: 'MRI' },
  { value: 'CT_SCAN', label: 'CT Scan' },
  { value: 'SONOGRAPHY', label: 'Sonography' },
  { value: 'ENDOSCOPY', label: 'Endoscopy' },
  { value: 'COLONOSCOPY', label: 'Colonoscopy' },
  { value: 'CBC', label: 'Complete Blood Count' },
  { value: 'LIVER_FUNCTION', label: 'Liver Function Test' },
  { value: 'KIDNEY_FUNCTION', label: 'Kidney Function Test' },
  { value: 'VITAMIN_D', label: 'Vitamin D' },
  { value: 'VITAMIN_B12', label: 'Vitamin B12' },
  { value: 'HBA1C', label: 'HbA1c' },
  { value: 'OTHER', label: 'Other' },
];

export const ADMISSION_TYPES: SelectOption[] = [
  { value: 'EMERGENCY', label: 'Emergency' },
  { value: 'PLANNED', label: 'Planned' },
  { value: 'DAY_CARE', label: 'Day Care' },
];

export const COLLECTION_TYPES: SelectOption[] = [
  { value: 'HOME_COLLECTION', label: 'Home Collection' },
  { value: 'LAB_VISIT', label: 'Lab Visit' },
  { value: 'EMERGENCY_COLLECTION', label: 'Emergency Collection' },
];

export const LAB_TYPES: SelectOption[] = [
  { value: 'GOVERNMENT', label: 'Government' },
  { value: 'PRIVATE', label: 'Private' },
  { value: 'SEMI_GOVERNMENT', label: 'Semi-Government' },
];

export const labelFor = (options: SelectOption[], value?: string): string =>
  options.find((o) => o.value === value)?.label ?? (value || '—');